import { Types } from './header';


const INITIAL_EXTRACTION = {
  status: 'IDLE', // 'IDLE' | 'RUNNING' | 'READY' | 'ERROR'
  error: null,
  key: null, // fingerprint of the inputs; see `buildExtractionKey`
  candidatesGeoJSON: null,
  requested: 0,
  extracted: 0,
};

const INITIAL_STATE = {
  loading: false,
  error: null,
  baselineCoords: null,
  referenceCoastlinesGeoJSON: null,
  modeledDistances: null,
  referenceDistances: null,
  mergedDistances: null,
  errorMetrics: null,
  aggregatedMetrics: null,
  measuredDeviation: null,
  extraction: INITIAL_EXTRACTION,
};

/**
 * @function reducer
 * @description Redux reducer for the Shore-S analysis duck. Tracks the loading/error state of
 * the validation run (`RUN`/`SET_LOADING`/`SET_ERROR`), stores the baseline drawn in
 * `ShoreSAnalysisSteps` for reuse by the export dialog, and holds the full result payload
 * (`SET_RESULT`) once `shoreSAnalysis/saga`'s `handleRun` completes.
 * @param {Object} [state=INITIAL_STATE] - Current Shore-S analysis state.
 * @param {Object} action - Dispatched Redux action.
 * **Called by:
 * @see {Redux store} - registered as the "shoreSAnalysis" reducer.
 * @memberof module:ShoreS
 * @returns {Object} The next Shore-S analysis state.
 */
export const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // The baseline is drawn in `ShoreSAnalysisSteps` and only travels through
    // the RUN payload; keeping it here is what lets the export dialog offer it
    // as a KML without having to thread it down as a prop.
    case Types.RUN:
      return { ...state, baselineCoords: action.payload.baselineCoords };

    case Types.SET_LOADING:
      return { ...state, loading: action.payload.loading };

    case Types.SET_ERROR:
      return { ...state, error: action.payload.error };

    case Types.SET_EXTRACTION:
      return { ...state, extraction: { ...state.extraction, ...action.payload } };

    case Types.SET_RESULT:
      return { ...state, ...action.payload, extraction: state.extraction, error: null };


    case Types.RESET_ANALYSIS:
      return { ...INITIAL_STATE, extraction: state.extraction };

    case Types.RESET:
      return INITIAL_STATE;

    default:
      return state;
  }
};

export default reducer;
